export default __webpack_public_path__ + "static/media/software-de-hoteleria-integrado.2a2b7c7a.png";